<template>
    <div class="chapter-container" :style="bgStyle" v-if="dataLoaded">
        <div>
             <div class="title-container col-12">
                <router-link :to="{ name: 'Detail', params: { source: getURLString(), id: $route.params.detail } }">
                    <h2>{{ getDetailTitle() }}</h2>
                </router-link>
            </div>
        </div>
        <prev_next_button 
            @clicked="prevNextClicked" 
            :top="true" 
            @settingClicked="settingClicked">
        </prev_next_button>
        <settings_view v-if="showSettings" 
            v-on-clickaway="away"
            @minusButtonClicked="minusButtonClicked" 
            @plusButtonClicked="plusButtonClicked"
            @fontSelected="fontSelected"
            @colorSelected="colorSelected"
            :fontSize="reactFontSize"
            :fontFamily="reactFontFamilyName"
            :backgroundColor="reactBgColorName"
            :lineHeight="reactLineHeight">
        </settings_view>
        <manga_chapter 
            :content="content" 
            :chapterTitle="getCurrentChapterTitle()" 
            :fontSize="reactFontSize" 
            :fontFamily="reactFontFamily"
            :bgColor="reactBgColor"
            :textColor="reactTextColor"
            :lineHeight="reactLineHeight">
        </manga_chapter>
        <prev_next_button 
            @clicked="prevNextClicked" 
            :top="false">
        </prev_next_button>
    </div>
</template>

<script>
import { HTTP } from "../common/http-common";
import recentMixins from "../common/recent-mixins"
import { mixin as clickaway } from 'vue-clickaway';

export default {
    name: "Chapter",
    mixins: [clickaway, recentMixins],
    data() {
        return {
            index: 0,
            detail: null,
            content: "",
            dataLoaded: false,
            showSettings: false,
            reactFontSize: 25,
            reactLineHeight: 180,
            reactFontFamily: '',
            reactFontFamilyName: '',
            reactTextColor: '',
            reactBgColor: '',
            reactBgColorName: ''
        }
    },
    components: {
        manga_chapter: () => import("@/components/manga-chapter"),
        prev_next_button: () => import("@/components/prev-next-button"),
        settings_view: () => import("@/components/settings-view")
    },
    methods: {
        getChapterData() {
            let path = this.source() + "_chapter_pages/"
            
            HTTP.get(path, {
                params: {
                    'chapterId': this.getCurrentChapter().url
                }
            })
            .then(response => {
                this.content = response.data["results"][0]["content"];
                this.dataLoaded = true
                this.saveRecentData(this.detail, this.getCurrentChapter())
            })
            .catch(e => {
                this.console.error(e);
            });
        },
        prevNextClicked(name) {
            var nextIndex = 0
            if (name == 'next') {
                nextIndex = parseInt(this.index) + parseInt(1)
            } else {
                nextIndex = parseInt(this.index) - parseInt(1)
            }
            nextIndex += 1
            if (nextIndex >= 1 && nextIndex <= this.detail.chapters.length) {
                nextIndex = `chuong-${nextIndex}`
                this.$router.push({ name: 'Chapter', params: { source: this.getURLString(), index: nextIndex }})
            }
        },
        getCurrentChapter() {
            if (this.detail == null) { return }
            return this.detail.chapters[this.index]
        },
        getCurrentChapterTitle() {
            let currentChapter = this.getCurrentChapter()
            if (currentChapter == null) { return "" }
            return currentChapter.title
        },
        getDetailTitle(){
            if (this.detail == null) { return "" }
            return this.detail.title
        },
        keyPress(e) {
            let keyCode = e.keyCode
            if (keyCode == 37) { this.prevNextClicked('prev') }
            if (keyCode == 39) { this.prevNextClicked('next') }
        },
        getDetailData() {
            if (this.detail != null) { return }

            let path = this.source() + "_new_info/"
            HTTP.get(path, {
                params: {
                    'mangaId': this.$route.params.detail.split("-").pop()
                }
            })
            .then(response => {
                this.detail = response.data["info"];
                if (this.source() != 'truyenfull') {
                    this.detail.chapters.reverse()
                }
                this.prepareChapterIndex()
                this.getChapterData()
            })
            .catch(e => {
                this.console.error(e);
            });
        },
        prepareChapterIndex() {
            let count = this.detail.chapters.length
            for (var index = 0; index < count; index++) {
                let chapter = this.detail.chapters[index]
                chapter["index"] = index + 1
            }
        },
        getIndex(route) {
            return route.params.index.split("-").pop() - 1
        },
        settingClicked() {
            this.showSettings = !this.showSettings
        },
        minusButtonClicked(name) {
            if (name == 'fontSize') { this.fontSize = parseInt(this.reactFontSize) - parseInt(1) }
            if (name == 'lineHeight') { this.lineHeight = parseInt(this.reactLineHeight) - parseInt(10) }
        },
        plusButtonClicked(name) {
            if (name == 'fontSize') { this.fontSize = parseInt(this.reactFontSize) + parseInt(1) }
            if (name == 'lineHeight') { this.lineHeight = parseInt(this.reactLineHeight) + parseInt(10) }
        },
        fontSelected(font) {
            this.fontFamily = font.cssId
        },
        colorSelected(color) {
            this.bgColor = color.cssId
        },
        setupProperties() {
            this.index = this.getIndex(this.$route)
            this.reactFontSize = this.fontSize
            this.reactLineHeight = this.lineHeight
            this.reactFontFamily = this.fontFamily
            this.reactFontFamilyName = this.getName(this.reactFontFamily)
            this.reactBgColor = this.bgColor
            this.reactTextColor = this.getTextColor(this.reactBgColor)
            this.reactBgColorName = this.getBgColorName(this.reactBgColor)
        },
        getName(fontFamily) {
            var name = fontFamily.split(',')[0]
            return name.replace(/'/g, '')
        },
        getTextColor(bgColor) {
            let dict = { '#FFF': '#000', '#000': '#FFF', '#F4ECD8': '#000' }
            return dict[bgColor]
        },
        getBgColorName(bgColor) {
            let dict = { '#FFF': 'Trắng', '#000': 'Đen', '#F4ECD8': 'Vàng' }
            return dict[bgColor]
        },
        away() {
            this.showSettings = false
        }
    },
    computed: {
        fontSize: {
            get() {
                return this.getFontSize()
            },
            set(newValue) {
                this.reactFontSize = newValue
                this.setFontSize(newValue)
            }
        },
        lineHeight: {
            get() {
                return this.getLineHeight()
            },
            set(newValue) {
                this.reactLineHeight = newValue
                this.setLineHeight(newValue)
            }
        },
        fontFamily: {
            get() {
                return this.getFontFamily()
            },
            set(newValue) {
                this.reactFontFamily = newValue
                this.reactFontFamilyName = this.getName(newValue)
                this.setFontFamily(newValue)
            }
        },
        bgColor: {
            get() {
                return this.getBgColor()
            },
            set(newValue) {
                this.reactBgColor = newValue
                this.reactTextColor = this.getTextColor(newValue)
                this.reactBgColorName = this.getBgColorName(newValue)
                this.setBgColor(newValue)
            }
        },
        bgStyle() {
            return {
                backgroundColor: this.reactBgColor
            }
        }
    },
    created() {
        this.setupProperties()
        this.getDetailData()
        window.addEventListener('keyup', this.keyPress)
    },
    beforeRouteUpdate(to, from, next) {
        this.index = this.getIndex(to)
        this.getChapterData()
        next()
    },
    destroyed() {
        window.removeEventListener('keyup', this.keyPress)
    },
    metaInfo() {
        return {
            title: `${ this.getDetailTitle() } - ${ this.getCurrentChapterTitle() }`,
            meta: [
                { name: 'description', content: "" },
                { property: 'og:title', content: `Bạn đang đọc truyện ${ this.getDetailTitle() } - ${ this.getCurrentChapterTitle() } trên website đọc truyện online.`},
                { property: 'og:site_name', content: 'Nover - Hay Đọc Truyện'},
                { property: 'og:type', content: 'website'},    
                { name: 'robots', content: 'index,follow'} 
            ],
            link: [
                { rel: 'canonical', href: `${ this.$route.fullPath }`}
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.chapter-container {
    outline: none;
    background: #F4ECD8;

    .title-container {
    padding-top: 2rem;
    padding-bottom: 1rem;

        h2 {
            font-size: 3rem;
            color: $subColor;
            font-weight: bold;
        }
    }
}
</style>